import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Notebook16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.5 2.25H3.75V3.25H4.5V4.75H3.75V7.25H4.5V8.75H3.75V11.25H4.5V12.75H3.75V13.75H12.75V8H14.25V14C14.25 14.6904 13.6904 15.25 13 15.25H3.5C2.80964 15.25 2.25 14.6904 2.25 14V12.75H1V11.25H2.25V8.75H1V7.25H2.25V4.75H1V3.25H2.25V2C2.25 1.30965 2.80964 0.75 3.5 0.75H8.5V2.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.6161 1.32327C12.1043 0.835115 12.8957 0.835114 13.3839 1.32327L14.6768 2.61616C15.1649 3.10432 15.1649 3.89577 14.6768 4.38393L10.3697 8.69095L8.01479 9.16194C7.31506 9.30188 6.69815 8.68496 6.83809 7.98524L7.30908 5.63029L11.6161 1.32327ZM12.5 2.56071L8.69088 6.36981L8.45605 7.54398L9.63022 7.30915L13.4393 3.50005L12.5 2.56071Z'
      fill='currentColor'
    />
  </Svg>
);

Notebook16.displayName = 'Notebook16';
export default Notebook16;
